module.exports = __webpack_public_path__ + "static/fonts/CoreUI-Icons-Free.564bebe.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/fonts/CoreUI-Icons-Free.eot?64h6xh
// module id = ZTMK
// module chunks = 2